import { useQuery } from "@tanstack/react-query";
import { getSimpleStepItemById } from "../../api/apiSimpleStepItems";

export function useGetSimpleStepItem(id) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["simple-step-item", id],
        queryFn: () => getSimpleStepItemById(id),
        enabled: !!id,
        retry: false,
    });

    const item = data?.data || null;

    return { isLoading, error, item, refetch };
}
